// src/features/userSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoginResponse } from 'subModule/src/services/userProfile/interface';
import { RootState } from 'app/store';

const storedUserInfo = localStorage.getItem('userInfo');
const initialState: LoginResponse = storedUserInfo ? JSON.parse(storedUserInfo) : {
  username: '',
  email: '',
  business: {
    id: 0,
    scrapItemGroupId: 0,
    primaryLanguage: '',
    secondaryLanguage: '',
    priceListId: 0,
    priceListTitle: '',
    taxProcedureId: 0,
    currency: '',
    title: '',
    secondaryTitle: '',
    active: false,
    whiteLabel: false,
    sellBelowStock: true,
    ownerCapital: null,
    vehiclePlateFormat: {},
    defaultEntity: {},
    zone: '',
    vendorId: 0,
    bankAccountId: 0,
  },
  type: 0,
  privileges: [],
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<LoginResponse>) => {
      localStorage.setItem('userInfo', JSON.stringify(action.payload));
      return {
        ...state,
        ...action.payload,
      };
    },
    clearUserInfo: () => {
      localStorage.removeItem('userInfo');
      return initialState;
    },
  },
});

export const { setUserInfo, clearUserInfo } = userSlice.actions;
export default userSlice.reducer;

export const selectUserInfo = (state: RootState) => state.user;